var map = {
	"./addBlack.svg": [
		1239,
		3
	],
	"./addWhite.svg": [
		1240,
		4
	],
	"./add_assignee.svg": [
		1241,
		5
	],
	"./additional.svg": [
		1242,
		6
	],
	"./asset.svg": [
		1243,
		7
	],
	"./assistant-blue.svg": [
		1244,
		8
	],
	"./assistant-grey.svg": [
		1245,
		9
	],
	"./attach.svg": [
		1246,
		10
	],
	"./bot.svg": [
		1247,
		11
	],
	"./camera.svg": [
		1248,
		12
	],
	"./cancel.svg": [
		1249,
		13
	],
	"./cancelOrder.svg": [
		1250,
		14
	],
	"./chat.svg": [
		1251,
		15
	],
	"./checklist.svg": [
		1252,
		16
	],
	"./client-comments.svg": [
		1253,
		17
	],
	"./client-delete.svg": [
		1254,
		18
	],
	"./confirmOrder.svg": [
		1255,
		19
	],
	"./content.svg": [
		1256,
		20
	],
	"./dashboard.svg": [
		1257,
		21
	],
	"./delete.svg": [
		1258,
		22
	],
	"./delivered.svg": [
		1259,
		23
	],
	"./diesel.svg": [
		1260,
		24
	],
	"./document.svg": [
		1261,
		25
	],
	"./edit-pencil.svg": [
		1262,
		26
	],
	"./energy.svg": [
		1263,
		27
	],
	"./enter.svg": [
		1264,
		28
	],
	"./expand.svg": [
		1265,
		29
	],
	"./gallery.svg": [
		1266,
		30
	],
	"./generateInvoice.svg": [
		1267,
		31
	],
	"./grey-right-arrow.svg": [
		1268,
		32
	],
	"./headcount.svg": [
		1269,
		33
	],
	"./import.svg": [
		1270,
		34
	],
	"./in progress.svg": [
		1271,
		35
	],
	"./instructions.svg": [
		1272,
		36
	],
	"./inventory.svg": [
		1273,
		37
	],
	"./invoice.svg": [
		1274,
		38
	],
	"./leftArr-blue.svg": [
		1275,
		39
	],
	"./leftArr-grey.svg": [
		1276,
		40
	],
	"./location.svg": [
		1277,
		41
	],
	"./locations.svg": [
		1278,
		42
	],
	"./mappingPeople.svg": [
		1279,
		43
	],
	"./message.svg": [
		1280,
		44
	],
	"./meter.svg": [
		1281,
		45
	],
	"./meters.svg": [
		1282,
		46
	],
	"./new-message.svg": [
		1283,
		47
	],
	"./people.svg": [
		1284,
		48
	],
	"./ppm.svg": [
		1285,
		49
	],
	"./prescription.svg": [
		1286,
		50
	],
	"./purchase_order.svg": [
		1287,
		51
	],
	"./qr.svg": [
		1288,
		52
	],
	"./qrCode.svg": [
		1289,
		53
	],
	"./refresh.svg": [
		1290,
		54
	],
	"./reminder-bell.svg": [
		1291,
		55
	],
	"./report.svg": [
		1292,
		56
	],
	"./right-arrow.svg": [
		1293,
		57
	],
	"./rightArr-blue.svg": [
		1294,
		58
	],
	"./rightArr-grey.svg": [
		1295,
		59
	],
	"./rules.svg": [
		1296,
		60
	],
	"./sales.svg": [
		1297,
		61
	],
	"./search.svg": [
		1298,
		62
	],
	"./selectedBot.svg": [
		1299,
		63
	],
	"./selectedChat.svg": [
		1300,
		64
	],
	"./selectedContent.svg": [
		1301,
		65
	],
	"./selectedDashboard.svg": [
		1302,
		66
	],
	"./send_message.svg": [
		1303,
		67
	],
	"./set_date.svg": [
		1304,
		68
	],
	"./shrink.svg": [
		1305,
		69
	],
	"./star.svg": [
		1306,
		70
	],
	"./tick.svg": [
		1307,
		71
	],
	"./tick_grey.svg": [
		1308,
		72
	],
	"./timer.svg": [
		1309,
		73
	],
	"./user.svg": [
		1310,
		74
	],
	"./vendor.svg": [
		1311,
		75
	],
	"./workorder.svg": [
		1312,
		76
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 872;
module.exports = webpackAsyncContext;